export const Taekwondo = [
    {
        "id": 58,
        "Title": "IES-2024-58",
        "ImageSource": "/Boxing/teakwondo uniforms/1.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 59,
        "Title": "IES-2024-59",
        "ImageSource": "/Boxing/teakwondo uniforms/2.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 60,
        "Title": "IES-2024-60",
        "ImageSource": "/Boxing/teakwondo uniforms/3.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 61,
        "Title": "IES-2024-61",
        "ImageSource": "/Boxing/teakwondo uniforms/4.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 62,
        "Title": "IES-2024-62",
        "ImageSource": "/Boxing/teakwondo uniforms/5.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 63,
        "Title": "IES-2024-63",
        "ImageSource": "/Boxing/teakwondo uniforms/6.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 64,
        "Title": "IES-2024-64",
        "ImageSource": "/Boxing/teakwondo uniforms/7.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 65,
        "Title": "IES-2024-65",
        "ImageSource": "/Boxing/teakwondo uniforms/8.jpg",
        "Category": "Taekwondo Uniform"
    },
    {
        "id": 66,
        "Title": "IES-2024-66",
        "ImageSource": "/Boxing/teakwondo uniforms/9.jpg",
        "Category": "Taekwondo Uniform"
    }
];
